const translations = {
    LOGIN_ATHLETE_HEADER: {
        primaryValue: "LOGIN WITH YOUR ATHLETE USERNAME & PASSWORD",
        stringKey: "LOGIN_ATHLETE_HEADER",
        description: "Header text for the login page"
    },
    EMPLOYEE_ID: {
        primaryValue: "Employee ID",
        stringKey: "EMPLOYEE_ID",
        description: "Label for the employee id input field"
    },
    STORE_NUMBER: {
        primaryValue: "Store Number",
        stringKey: "STORE_NUMBER",
        description: "Label for the store number input field"
    },
    SELECT_COUNTRY: {
        primaryValue: "Select Country",
        stringKey: "SELECT_COUNTRY",
        description: "Label for the country selection dropdown"
    },
    LOGIN_PASSWORD: {
        primaryValue: "Password",
        stringKey: "LOGIN_PASSWORD",
        description: "Label for the password input field"
    },
    LOGIN_NO_ATHLETE_LINK: {
        primaryValue: "Don't have Athlete credentials? Login with your Nike Account",
        stringKey: "LOGIN_NO_ATHLETE_LINK",
        description: "Text for the link to the athlete account creation page"
    },
    LOGIN_SUBMIT_FORM: {
        primaryValue: "Login",
        stringKey: "LOGIN_SUBMIT_FORM",
        description: "Text for the submit button on the login form"
    },
    INVALID_LOGIN_CREDENTIALS: {
        primaryValue: "Incorrect username or password. Please check the details and try again or contact your manager. Also, ensure you are connected to the Nike network",
        stringKey: "INVALID_LOGIN_CREDENTIALS",
        description: "Error message for invalid login credentials"
    },
    LOGIN_SERVER_ERROR: {
        primaryValue: "Unable to connect to server. Please try again later.",
        stringKey: "LOGIN_SERVER_ERROR",
        description: "Error message for server error during login"
    }
}

export default translations;